<template>
  <div>
    <mdb-btn color="primary" @click="createNewChecklist">Create New Checklist</mdb-btn>
    <mdb-list-group v-if="checklists">
      <mdb-list-group-item
        v-for="checklist in checklists"
        :key="checklist.id"
        class="d-flex justify-content-between align-items-center"
      >
        <div>
          <h5>{{ checklist.name }}</h5>
          <p class="mb-1">{{ checklist.project_name }}</p>
          <small>{{ checklist.user_email }}</small>
        </div>
        <mdb-btn
          @click="goToChecklist(checklist.id)"
        >Edit</mdb-btn>
      </mdb-list-group-item>
    </mdb-list-group>
  </div>
</template>

<script>
import { mdbBtn, mdbListGroup, mdbListGroupItem } from 'mdbvue';
import Apicall from '@/libs/Apicall';

export default {
  components: {
    mdbBtn,
    mdbListGroup,
    mdbListGroupItem,
  },
  data() {
    return {
      checklists: null,
    };
  },
  mounted() {
    this.fetchChecklists();
  },
  methods: {
    goToChecklist(id) {
      this.$router.push(`/admin/checklist/edit/${id}`);
    },
    createNewChecklist() {
      // Implement your create new checklist logic here
      console.log('Create new checklist');
      this.$router.push('/admin/checklist/new');
    },
    async fetchChecklists() {
      try {
        const api = new Apicall();
        const response = await api.call('GET', 'api/adminchecklist/all');
        this.checklists = response.data;
      } catch (error) {
        console.error('Error fetching checklists:', error);
      }
    },
  },
};
</script>
